import { z } from 'zod';
// One reports table, `config` discriminated on `type`. The shared source of
// truth for the shape, reused by the admin types and POST /api/reports.
export const reportStepSchema = z.object({
    id: z.string(),
    type: z.enum(['Pageview', 'Event']),
    value: z.string().optional(),
});
export const funnelReportConfigSchema = z.object({
    type: z.literal('funnel'),
    steps: z.array(reportStepSchema),
});
export const journeyAnchorSchema = z.object({
    type: z.enum(['Pageview', 'Event']),
    value: z.string(),
});
export const journeyReportConfigSchema = z.object({
    type: z.literal('journey'),
    anchor: journeyAnchorSchema,
    direction: z.enum(['forward', 'backward']).optional(),
    depth: z.number(),
    topK: z.number().optional(),
    minCount: z.number().optional(),
    excludeEvents: z.array(z.string()).optional(),
});
export const reportConfigSchema = z.discriminatedUnion('type', [
    funnelReportConfigSchema,
    journeyReportConfigSchema,
]);
export const createReportRequestSchema = z.object({
    projectId: z.string().min(1),
    name: z.string().trim().min(1).max(255),
    description: z.string().trim().max(1000).optional(),
    config: reportConfigSchema,
});
//# sourceMappingURL=reports.js.map